import { render, staticRenderFns } from "./LocationReviews.vue?vue&type=template&id=157501c2"
import script from "./LocationReviews.vue?vue&type=script&lang=js"
export * from "./LocationReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports